import {
  CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  createNegativeMediaIgnoringProperty,
  createNegativeMediaIgnoringPropertyPending,
  createNegativeMediaIgnoringPropertyFulfilled,
  createNegativeMediaIgnoringPropertyRejected,
} = createAsyncActions(CREATE_NEGATIVE_MEDIA_IGNORING_PROPERTY, 'createNegativeMediaIgnoringProperty');


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/createNegativeMediaIgnoringPropertyActions.js